import React, { useState, useEffect, useRef } from 'react';
import '../styles/career.css';
import Swal from "sweetalert2";

export default function Career() {
  useEffect(() => {
    document.title = "Career | Inypeople";
  }, []);
  const [showJobDetails, setShowJobDetails] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const resumeRef = useRef(null);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    experience: "",
    position: "",
    location: "",
    resume: null,
    resumeName: "",   // ✅ ADD THIS LINE ONLY
  });

const handleSubmit = async (e) => {
  e.preventDefault();

  if (submitting) return;  // ✅ prevent double submit
  setSubmitting(true);     // ✅ lock the button

  const data = new FormData();
  data.append("fullName", formData.fullName);
  data.append("email", formData.email);
  data.append("phone", formData.phone);
  data.append("experience", formData.experience);
  data.append("position", formData.position);
  data.append("location", formData.location);
  data.append("resume", formData.resume);

  try {
    const API = process.env.REACT_APP_API_URL;
    const response = await fetch(`${API}/apply-job`, {
      method: "POST",
      body: data,
    });

    if (response.ok) {
      Swal.fire({
        icon: "success",
        title: "Application Submitted",
        text: "Your job application has been submitted successfully!",
        confirmButtonText: "OK",
      });
      setFormData({
        fullName: "", email: "", phone: "", experience: "",
        position: "", location: "", resume: null, resumeName: "",
      });
    } else {
      Swal.fire({ icon: "error", title: "Failed", text: "Failed to submit application", confirmButtonText: "Try Again" });
    }
  } catch (error) {
    console.error(error);
    Swal.fire({ icon: "error", title: "Server Error", text: "Something went wrong. Please try again later.", confirmButtonText: "OK" });
  } finally {
    setSubmitting(false);  // ✅ always unlock after done
  }
};


  return (
    <div className="career-page">

      {/* =========================
          HERO SECTION
      ========================= */}
      <section className="career-hero-container">
        <div className="career-hero-content">
          <div className="career-hero-grid">

            {/* LEFT CONTENT */}
            <div className="text-content">
              <h1 className="hero-heading">
                Your Career Partner in{' '}
                <span className="highlight-text">Recruitment</span>
              </h1>

              <p className="hero-description">
                We believe great work begins with great people. At Inypeople,
                collaboration and creativity fuel everything we build. Come be part
                of a team committed to learning, growth, and excellence.
              </p>
            </div>

            {/* RIGHT IMAGE + OVAL */}
            <div className="image-section">
              <div className="image-card">

                {/* IMAGE ABOVE OVAL */}
                <img
                  src={"/assets/images/careers_hero.png"}
                  alt="Careers Hero"
                  className="career-hero-image"
                />

                <div className="career-floating-card">
                  <div className="floating-icon">
                    <img
                      src={"/assets/images/floting_card_icon.png"}
                      alt="Career Icon"
                      className="floating-icon-img"
                    />
                  </div>

                  <p>
                    A job career refers to<br />
                    long-term professional
                  </p>
                </div>

                {/* PURPLE OVAL */}
                <div className="career-oval-bg"></div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* =========================
          CAREER OPPORTUNITIES SECTION
      ========================= */}
      <section className="career-opportunities-section">
        <div className="opportunities-header">
          <p className="section-label">POSITIONS</p>
          <h2 className="section-title">Career Opportunities</h2>
        </div>

        <div className="career-cards-grid">
          {/* Card 1 - .Net Tech Lead */}
          <div className="career-card">
            <h3 className="career-card-title">.Net Tech Lead</h3>
            <p className="career-card-subtitle">
              Experience: 5+ years<br />

              Location: Chennai
            </p>



            <div className="card-details">
              <p>
                Responsibilities:
                <br />
                Design and develop the web applications using C#, ASP.NET, and .NET Core
                <br />
                Develop scalable and efficient back-end APIs using ASP.NET Web API and ASP.NET Core Web API
                <br />
                Work with our data team to design and implement data models and integrations using Entity Framework Core, ADO.NET
                Exposure to SQL databases will be added advantage.
              </p>
            </div>




            <button
              className="learn-more-btn"
              onClick={() => {
                setSelectedJob("dotnet");
                setShowJobDetails(true);

              }}
            >
              Learn More <span className="arrow">→</span>
            </button>


          </div>

          {/* Card 2 - AR Caller */}
          <div className="career-card">
            <h3 className="career-card-title">Job Description For AR Caller</h3>
            <p className="career-card-subtitle">Title: Process Trainee – AR Caller</p>
            <div className="card-details">
              <p>
                Desired Candidate Profile
                <br />
                Immediate Joiners with Excellent Communication in English.
                <br />
                Strong written and verbal communication skills.
                <br />
                Any Graduates between 2022 – 2025 Passed out are eligible to apply.
                <br />
                Ability to prioritize and manage work queue.
                <br />
                Ability to work independently as well as in a team environment.
              </p>
            </div>

            <button
              className="learn-more-btn-2"
              onClick={() => {
                setSelectedJob("arcaller");
                setShowJobDetails(true);

              }}
            >
              Learn More <span className="arrow">→</span>
            </button>

          </div>
          {/* Card 3 - Oracle EPM Consultant */}
          <div className="career-card">
            <h3 className="career-card-title">Oracle EPM Consultant</h3>
            <p className="career-card-subtitle">EPBCS & Tax Reporting</p>
            <div className="card-details">
              <p>
                (EPM) Consultant with deep expertise in Enterprise Planning and Budgeting Cloud
                Service (EPBCS) and Tax Reporting Cloud Service (TRCS).<br /> The ideal candidate will
                lead design, configuration, and implementation of Oracle EPM Cloud solutions that
                streamline financial planning, forecasting, consolidation, and tax provisioning for our
                clients.
              </p>
            </div>




            <button
              className="learn-more-btn-3"
              onClick={() => {
                setSelectedJob("epm");
                setShowJobDetails(true);

              }}
            >
              Learn More <span className="arrow">→</span>
            </button>



          </div>
        </div>
      </section>
      {showJobDetails && (
        <div className="job-details-section">

          {selectedJob === "dotnet" && (
            <>
              <h1 className="job-title">.Net Tech Lead</h1>
              <p className="job-meta">Experience: 5+ Years, Location: Chennai</p>

              <div className="job-description">
                <h3><span className="word1">Responsibilities:</span></h3>
                <p>Design and develop the web applications using C#, ASP.NET, and .NET Core</p>
                <p>Develop scalable and efficient back-end APIs using ASP.NET Web API and ASP.NET Core Web API</p>
                <p>Work with our data team to design and implement data models and integrations using Entity Framework Core, ADO.NET</p>
                <p>Exposure to SQL databases will be added advantage.</p>
                <p>Good understanding of mandatory scripting languages JQuery and JavaScript.</p>
                <p>Participate in code reviews and ensure that all code meets high standards of quality and maintainability</p>
                <p>Troubleshoot and debug issues with our applications using debugging tools such as Visual Studio Code or Visual Studio</p>
              </div>
            </>
          )}

          {selectedJob === "arcaller" && (
            <>
              <h1 className="job-title">Job Description For AR Caller</h1>
              <p className="job-meta">Job Description For AR Caller</p>

              <div className="job-description-2">
                <h3><span className="word1">Desired Candidate Profile </span></h3>
                <p>Immediate Joiners with Excellent Communication in English.</p>
                <p>Strong written and verbal communication skills. </p>
                <p>Any Graduates between 2022 – 2025 Passed out are eligible to apply. </p>
                <p>Ability to prioritize and manage work queue. </p>
                <p>Ability to work independently as well as in a team environment. </p>
                <p>Expert in listening and solving problems  </p>
                <p>Proficient in delivering high quality results.  </p>
                <p>Capable of grasping new concepts quickly. </p>
                <p>Flexible to work with any shift timings. </p>

              </div>

              <div className="job-description-2">
                <h3><span className="word1">AR Caller (Voice Process) </span></h3>
                <p>1.⁠ ⁠Calling Insurance Company on behalf of healthcare providers for claim status.</p>
                <p>2.⁠ ⁠Should handle US Healthcare Providers Billing.  </p>
                <p>3.⁠ ⁠Follow-up with Insurance Company to check status of outstanding claims. </p>
                <p>4.⁠ ⁠Receive payment information if the claims have been processed.  </p>
                <p>5.⁠ ⁠Analyze claims in case of rejections.  </p>
                <p>6.⁠ ⁠Ensure deliverable adhere to quality standards </p>


              </div>

              <div className="job-description-2">
                <h3><span className="word1">Essential Functions </span></h3>
                <p>•⁠ ⁠Performance Standards: Meet or exceed productivity and quality standards to ,</p>
                <p>deliver superior client experience. Ensure the work performed does not result in any </p>
                <p>client dissatisfaction.</p>
                <p>•⁠  ⁠Innovation: Share ideas and thoughts on how the process can be improved </p>
                <p> further to augment efficiency and effectiveness. Find ways to participate in</p>
                <p>implementing those ideas. </p>
                <p>•⁠  ⁠Knowledge: Take efforts to understand the entire RCM so that the context of the </p>
                <p> AR process is understood and performed effectively.  </p>



              </div>

              <div className="job-description-2">
                <h3><span className="word1">Key Competencies  </span></h3>
                <p>•⁠  ⁠Exceptional typing and communication skills (verbal and written). </p>
                <p>•⁠  ⁠Organized, detail-oriented and self-motivated. Ability to juggle multiple  </p>
                <p>Responsibilities.</p>
                <p>•⁠  ⁠Exceptional problem-solving skills to analyze issues and identify potential </p>
                <p>liabilities.</p>
                <p>•⁠  ⁠Ability to maintain strong professional relationships with internal teams and</p>
                <p> management. </p>
                <p>•⁠  ⁠Consistent demonstration of a professional, positive attitude. </p>
                <p>•⁠  ⁠A strong, working understanding of computers, MS excel and an ability to self </p>
                <p> troubleshoot simple issues. </p>



              </div>
              <div className="job-description-2">
                <h3><span className="word1">Interview Process  </span></h3>
                <p>Level 1 --Online Assessment   </p>
                <p>Level 2 – HR Interview </p>




              </div>
            </>
          )}

          {selectedJob === "epm" && (
            <>
              <h1 className="job-title">Oracle EPM Consultant</h1>
              <p className="epm-job-meta">(EPM) Consultant with deep expertise in Enterprise Planning and Budgeting Cloud Service (EPBCS) and Tax Reporting Cloud Service (TRCS). The ideal candidate will lead design, configuration, and implementation of Oracle EPM Cloud solutions that streamline financial planning, forecasting, consolidation, and tax provisioning for our clients.</p>

              <div className="job-description-3">
                <h3><span className="word1">Key Responsibilities:</span></h3>
                <p>• Lead end-to-end implementation of EPBCS and Tax Reporting Cloud Service modules.</p>
                <p>• Experience with other EPM modules such as FCCS, ARCS etc.</p>
                <p>• Translate business requirements into scalable technical and functional designs.</p>
                <p>• Configure planning models, forms, rules, and calculation scripts.</p>
                <p>• Develop tax provisioning models, deferred tax calculations, and effective tax rate reporting.</p>
                <p>• Integrate EPM with Oracle ERP Cloud, Fusion GL, and external data sources (via Data Management / Data Exchange).</p>
                <p>• Define chart of accounts mapping, data validation, and dimensional modeling.</p>
                <p>• Manage EPM automation (EPMAutomate, Groovy, REST API).</p>
                <p>• Conduct workshops, UAT sessions, and end-user training.</p>
              </div>

              <div className="job-description-3">
                <h3><span className="word1">Required Qualifications:</span></h3>
                <p>• ⁠Bachelor’s Degree in Finance, Accounting, Information Systems, or related field.</p>
                <p>• ⁠7+ years of overall experience in Oracle EPM / Hyperion Suite.</p>
                <p>• ⁠3+ years of hands-on experience with Oracle EPBCS.</p>
                <p>• 2+ years of experience in Tax Reporting Cloud Service (TRCS).</p>
                <p>• ⁠Proficiency in Smart View, EPM Automate, Groovy scripting, and Calculation</p>

              </div>

              <div className="job-description-3">
                <h3><span className="word1">Manager.</span></h3>
                <p>• ⁠Experience with Oracle Data Management (FDMEE) or EDMCS, FCCS, ARCS.</p>
                <p>• ⁠Working knowledge of Fusion GL / ERP integration, FAW, and narrative reporting.</p>


              </div>

              <div className="job-description-3">
                <h3><span className="word1">Preferred Skills:</span></h3>
                <p>• ⁠Oracle EPM Cloud certification (EPBCS or TRCS).</p>
                <p>• ⁠Exposure to FCCS, ARCS, or EDMCS.</p>
                <p>•⁠Experience implementing automation and AI-driven forecasting models</p>


              </div>
            </>
          )}

        </div>
      )}


      {/* APPLICATION FORM SECTION */}
      <div className="application-form-section">
        <div className="form-container">
          <div className="form-header">
            <h2 className="form-title">APPLY FOR A POSITION</h2>
            <p className="form-subtitle">
              We Bring People, Skills, And Businesses Together Globally, Creating Meaningful Careers Within
              Inypeople And For Our Clients.
            </p>
          </div>

          <form className="application-form" onSubmit={handleSubmit}>
            <h3 className="section-heading">Personal Information</h3>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">
                  Full Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  required
                  placeholder="Full Name"
                  value={formData.fullName}
                  onChange={(e) =>
                    setFormData({ ...formData, fullName: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">
                  Email ID<span className="required">*</span>
                </label>

                <input
                  type="email"
                  required
                  placeholder="Enter Email ID"
                  pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
                  title="Enter a valid email address"
                  value={formData.email}
                  onChange={(e) =>
                    setFormData({ ...formData, email: e.target.value })
                  }
                />

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone number">
                  Phone Number<span className="required">*</span>
                </label>
                <input
                  type="tel"
                  required
                  placeholder="Enter Phone Number"
                  pattern="[0-9]{10}"
                  maxLength="10"
                  title="Enter a valid 10-digit phone number"
                  value={formData.phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setFormData({ ...formData, phone: value });
                  }}
                />

              </div>

              <div className="form-group">
                <label htmlFor="experience">
                  Experience<span className="required">*</span>
                </label>

                <input
                  type="text"
                  placeholder="Enter Experience"
                  value={formData.experience}
                  onChange={(e) =>
                    setFormData({ ...formData, experience: e.target.value })
                  }
                />
              </div>


            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="position">
                  Position Applying for<span className="required">*</span>
                </label>
                <input
                  type="text"
                  required
                  placeholder="Enter Your Position"
                  value={formData.position}
                  onChange={(e) =>
                    setFormData({ ...formData, position: e.target.value })
                  }
                />
              </div>

              <div className="form-group">
                <label htmlFor="location">
                  Location<span className="required">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter Your Location"
                  value={formData.location}
                  onChange={(e) =>
                    setFormData({ ...formData, location: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="form-group full-width">
              <label htmlFor="position">
                Resume/CV<span className="required">*</span>
              </label>

              <div
                className="file-upload-box"
                onClick={() => resumeRef.current.click()}  // ✅ ADD THIS
              >

                <input
                  ref={resumeRef}  // ✅ ADD THIS
                  type="file"
                  id="resume"
                  accept=".pdf,.doc,.docx"
                  required
                  hidden
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setFormData({
                        ...formData,
                        resume: file,
                        resumeName: file.name
                      });
                    }
                  }}
                />


                {/* <-- Replace this label with a div */}
                <div className="file-upload-label">
                  <svg width="30" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 15V3M12 3L8 7M12 3L16 7"
                      stroke="#B0B0B0"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                    <path
                      d="M2 17L2 19C2 20.1046 2.89543 21 4 21L20 21C21.1046 21 22 20.1046 22 19V17"
                      stroke="#B0B0B0"
                      strokeWidth="3"
                      strokeLinecap="round"
                    />
                  </svg>

                  <span className="upload-text">
                    {formData.resumeName
                      ? formData.resumeName
                      : "Click Upload Your Resume (PDF, DOC, DOCX)"}
                  </span>
                </div>
              </div>
            </div>


            <button type="submit" className="submit-btn" disabled={submitting}>
  {submitting ? "Submitting..." : "Submit"}
</button>
          </form>
        </div>
      </div>


    </div>
  );
}